// extracted by mini-css-extract-plugin
module.exports = {"title":"title--FFUzG","name":"name--FjoLM"};